import { useServicesContext } from "@modules/core/services/services.context"
import { ProgramFilter } from "@modules/programs/programTypes"
import { useQuery } from "@tanstack/react-query"

export const useProgramInfinite = (id?: string) => {
  const { programInfiniteService } = useServicesContext()

  const { data, isLoading, isRefetching, error } = useQuery({
    queryKey: ["infiniteProgram", id],
    queryFn: async () => {
      if (!id) return null

      return await programInfiniteService.getProgramInfinite(id)
    },
    enabled: !!id,
  })

  return {
    result: data,
    isRefetching,
    isLoading,
    error,
  }
}

export const useProgramsInfinite = (options: {
  programFilter?: ProgramFilter
  page?: number
  size?: number
  sort?: "SUBSCRIPTION_DATE" | "CREATION_DATE"
}) => {
  const { programInfiniteService } = useServicesContext()

  const { data, isLoading, refetch } = useQuery({
    queryKey: ["infinitePrograms", options.programFilter, options.page, options.size, options.sort],
    queryFn: async () => {
      return programInfiniteService.getInfinitePrograms(
        options.sort ?? "SUBSCRIPTION_DATE",
        options.programFilter ?? "ALL",
        options.page,
        options.size,
      )
    },
  })

  return {
    data,
    isLoading,
    refetch,
  }
}
